export const getLineChartSymbol = index => {
  const symbols = ['triangle-down', 'circle', 'square', 'triangle', 'diamond'];
  return symbols[index % symbols.length];
};

export const getColorFromIndex = (index, colors) => {
  if (!Array.isArray(colors) || colors.length === 0) return null;
  return colors[index % colors.length];
};

export const underscoreToText = (str = '') => {
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
